import type { QueryClient } from '@tanstack/react-query';
import { clearTrackedAriOperations } from '@/features/properties/ari-edit';
import { onIdentityChange } from '@/shared/auth';
import { clearScopeSelections } from '@/shared/object-scope';

/**
 * Nach jedem Wechsel von Benutzer, Workspace oder Support-Sitzung ist nichts aus dem vorigen
 * Kontext mehr sichtbar: laufende Abfragen enden, der Cache ist leer, und Objekt-, Reinigungs- und
 * Übertragungsauswahl beginnen neu. Nur das Wiederherstellen nach einem Neuladen behält die
 * Ablagen, denn dort kehrt dieselbe Identität zurück.
 */
export function resetOnIdentityChange(queryClient: QueryClient): () => void {
  return onIdentityChange(({ restored }) => {
    void queryClient.cancelQueries();
    queryClient.clear();
    if (restored) return;
    clearScopeSelections();
    clearTrackedAriOperations();
  });
}
